import { Helmet } from "react-helmet";
import { Layout } from "@/components/layout/Layout";

export default function ManagerTermsPage() {
  return (
    <Layout>
      <Helmet>
        <title>Property Manager Agreement | StayMiddle</title>
        <meta name="description" content="Property Manager Agreement for StayMiddle platform" />
      </Helmet>
      
      <div className="container max-w-4xl py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold mb-8 text-center">StayMiddle Property Manager Agreement</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-muted-foreground mb-6">
              This agreement outlines the terms between StayMiddle ("Platform") and you ("Manager") 
              for listing and managing properties on the StayMiddle marketplace.
            </p>
            
            <p className="text-muted-foreground mb-8">
              By registering as a Manager, you agree to:
            </p>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">1. Property Listings</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You confirm you are authorized to manage or represent the properties you list.</li>
                <li>You are responsible for keeping calendar, pricing, and amenities accurate.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">2. Pricing and Bookings</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You may set a base nightly price and fees.</li>
                <li>You agree that final guest pricing may vary if shared via agent or manager link with markup.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">3. Payment Terms</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>StayMiddle processes guest payments and releases your portion via Stripe Connect.</li>
                <li>You are responsible for registering your payout method and complying with Stripe's onboarding requirements.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">4. Availability and Calendar Sync</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are expected to keep calendars synced using iCal or manual updates.</li>
                <li>Double bookings due to outdated calendars may result in penalties.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">5. Liability</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are solely responsible for property maintenance, guest communication, and resolving complaints.</li>
                <li>StayMiddle is not liable for damages or disputes between guests and managers.</li>
              </ul>
            </div>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">6. Termination</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>StayMiddle reserves the right to suspend or terminate accounts violating these terms.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}